export default "__VITE_ASSET__e9758d1e__"